<template>
<div class="CF">
  <div class="aitj">
    <p>AI推荐处方方案：</p>
  </div>
  <div class="yopss">
    <p>处方数据</p>
    <p style="padding-left: 10px;">使用类型：</p>
    <el-select v-model="cfValue" style="width: 150px; margin-right: 10px;" class="sr" size="mini" placeholder="请选择">
      <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
    <el-button type="primary" @click="addcf" size="mini">添加处方</el-button>
    <p style="padding-left: 30px;">佩戴方式：</p>
    <el-select size="mini" style="width: 150px;" v-model="postData.S_OP_Json.Scene_WearingMethod" placeholder="请选择">
      <el-option
          v-for="item in pdfs"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>

  <div class="contenss">
    <div v-for="item in cfarr">
      <div class="cfyy" v-if="item.S_OP_Json.S_OP_IO_Type == 0">
        <ul>
          <li>远用</li>
          <li>球镜</li>
          <li>柱镜</li>
          <li>轴向</li>
          <li>ADD</li>
          <li>远用矫正视力</li>
          <li>近用矫正视力</li>
          <li>瞳距</li>
          <li>瞳高</li>
          <li>垂直棱镜</li>
          <li>垂直基底</li>
          <li>水平棱镜</li>
          <li>水平基底</li>
        </ul>
        <ul>
          <li>OD</li>
          <li><input @change="jhbh($event, item, 'S_OP_IO_DSOD')" v-model="item.S_OP_Json.S_OP_IO_DSOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_DCOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_XOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_ADDOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_DVAOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_NVAOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_PDOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_PHOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_ArriseOD_V" type="text"></li>
          <li>
            <el-select v-model="item.S_OP_Json.S_OP_IO_BasisOD_V" size="mini" filterable allow-create placeholder="">
              <el-option
                  v-for="item in czjd"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_ArriseOD" type="text"></li>
          <li>
            <el-select v-model="item.S_OP_Json.S_OP_IO_BasisOD" size="mini" filterable allow-create placeholder="" >
              <el-option
                  v-for="item in jd"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </li>
        </ul>
        <ul>
          <li>OS</li>
          <li><input @change="jhbh($event, item, 'S_OP_IO_DSOS')" v-model="item.S_OP_Json.S_OP_IO_DSOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_DCOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_XOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_ADDOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_DVAOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_NVAOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_PDOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_PHOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_ArriseOS_V" type="text"></li>
          <li>
            <el-select v-model="item.S_OP_Json.S_OP_IO_BasisOS_V" size="mini" filterable allow-create placeholder="">
              <el-option
                  v-for="item in czjd"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_ArriseOS" type="text"></li>
          <li>
            <el-select v-model="item.S_OP_Json.S_OP_IO_BasisOS" size="mini" filterable allow-create placeholder="" >
              <el-option
                  v-for="item in jd"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </li>
        </ul>
      </div>

      <div class="cfjy" v-if="item.S_OP_Json.S_OP_IO_Type == 2">
        <ul>
          <li>近用</li>
          <li>球镜</li>
          <li>柱镜</li>
          <li>轴向</li>
          <li>近用视力矫正</li>
          <li>瞳距</li>
        </ul>
        <ul>
          <li>OD</li>
          <li><input @change="jhbh($event, item, 'S_OP_IO_DSOD')"  v-model="item.S_OP_Json.S_OP_IO_DSOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_DCOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_XOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_VAOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_PDOD" type="text"></li>
        </ul>
        <ul>
          <li>OS</li>
          <li><input @change="jhbh($event, item, 'S_OP_IO_DSOS')" v-model="item.S_OP_Json.S_OP_IO_DSOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_DCOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_XOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_VAOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_PDOS" type="text"></li>
        </ul>
      </div>

      <div class="cfjmjcj" v-if="item.S_OP_Json.S_OP_IO_Type == 7">
        <ul>
          <li>角膜接触镜</li>
          <li>球镜</li>
          <li>柱镜</li>
          <li>轴向</li>
          <li>视力</li>
          <li>基弧</li>
          <li>镜片直径</li>
        </ul>
        <ul>
          <li>OD</li>
          <li><input @change="jhbh($event, item, 'S_OP_IO_DSOD')" v-model="item.S_OP_Json.S_OP_IO_DSOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_DCOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_XOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_VAOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_BCOD" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_DIMOD" type="text"></li>
        </ul>
        <ul>
          <li>OS</li>
          <li><input @change="jhbh($event, item, 'S_OP_IO_DSOS')" v-model="item.S_OP_Json.S_OP_IO_DSOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_DCOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_XOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_VAOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_BCOS" type="text"></li>
          <li><input v-model="item.S_OP_Json.S_OP_IO_DIMOS" type="text"></li>
        </ul>
      </div>
    </div>
  </div>

  <div style="text-align: center;">
    <el-button type="primary" @click="saves">保存</el-button>
    <el-button type="primary" @click="sgsqm">视光师签名</el-button>
  </div>

</div>
</template>

<script>
import {cfObj, gbjh} from './xzdata'
import {saveFA} from './api'

export default {
  name: "CF",
  data() {
    return {
      postData: {
        S_OP_Json: {}
      },
      cfValue: '',
      options: cfObj.cflx,
      pdfs: cfObj.pdfs,
      ysArr: [
        {
          S_OP_ChooseId: this.$store.state.physicianVisits.xzConsulting,
          S_OP_CustomerId: this.$store.state.users.CsUser.CustomerId,
          S_OP_ExpertId: this.$store.state.users.employees?this.$store.state.users.employees.ExpertId:'00000000-0000-0000-0000-000000000000',
          S_OP_ID: "00000000-0000-0000-0000-000000000000",
          S_OP_Json:{
            S_OP_IO_ADDOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_AddOD,
            S_OP_IO_ADDOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_AddOS,
            S_OP_IO_ArriseOD: "",
            S_OP_IO_ArriseOS: "",
            S_OP_IO_BCOD: "",
            S_OP_IO_BCOS: "",
            S_OP_IO_BasisOD: "",
            S_OP_IO_BasisOS: "",
            S_OP_IO_ChooseId: this.$store.state.physicianVisits.xzConsulting,
            S_OP_IO_DCOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DCOD,
            S_OP_IO_DCOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DCOS,
            S_OP_IO_DIMOD: "",
            S_OP_IO_DIMOS: "",
            S_OP_IO_DSOD:gbjh(this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DSOD) ,
            S_OP_IO_DSOS:gbjh(this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DSOS) ,
            S_OP_IO_DVAOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DVAOD,
            S_OP_IO_DVAOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DVAOS,
            S_OP_IO_FrameType: "",
            S_OP_IO_NVAOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_NVAOD,
            S_OP_IO_NVAOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_NVAOS,
            S_OP_IO_Number: "",
            S_OP_IO_PDOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_PDOD,
            S_OP_IO_PDOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_PDOS,
            S_OP_IO_PHOD: "",
            S_OP_IO_PHOS: "",
            S_OP_IO_Remark: "",
            S_OP_IO_Type: "0",
            S_OP_IO_VAOD: "",
            S_OP_IO_VAOS: "",
            S_OP_IO_XOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_XOD,
            S_OP_IO_XOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_XOS,
            S_OP_IO_ArriseOD_V: '',
            S_OP_IO_BasisOD_V: '',
            S_OP_IO_BasisOS_V: '',
            S_OP_IO_ArriseOS_V: '',
          },
          S_OP_Model: "S_OP_IO",
          S_OP_Type: "Inspection"
        },
        {
          S_OP_ChooseId: this.$store.state.physicianVisits.xzConsulting,
          S_OP_CustomerId: this.$store.state.users.CsUser.CustomerId,
          S_OP_ExpertId: this.$store.state.users.employees?this.$store.state.users.employees.ExpertId:'00000000-0000-0000-0000-000000000000',
          S_OP_ID: "00000000-0000-0000-0000-000000000000",
          S_OP_Json:{
            S_OP_IO_ADDOD: '',
            S_OP_IO_ADDOS: '',
            S_OP_IO_ArriseOD: "",
            S_OP_IO_ArriseOS: "",
            S_OP_IO_BCOD: "",
            S_OP_IO_BCOS: "",
            S_OP_IO_BasisOD: "",
            S_OP_IO_BasisOS: "",
            S_OP_IO_ChooseId: this.$store.state.users.employees.ExpertId,
            S_OP_IO_DCOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DCOD,
            S_OP_IO_DCOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DCOS,
            S_OP_IO_DIMOD: "",
            S_OP_IO_DIMOS: "",
            S_OP_IO_DSOD:gbjh(this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DSOD) ,
            S_OP_IO_DSOS:gbjh(this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DSOS) ,
            S_OP_IO_DVAOD: "",
            S_OP_IO_DVAOS: "",
            S_OP_IO_FrameType: "",
            S_OP_IO_NVAOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_NVAOD,
            S_OP_IO_NVAOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_NVAOS,
            S_OP_IO_Number: "",
            S_OP_IO_PDOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_PDOD,
            S_OP_IO_PDOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_PDOS,
            S_OP_IO_PHOD: "",
            S_OP_IO_PHOS: "",
            S_OP_IO_Remark: "",
            S_OP_IO_Type: "2",
            S_OP_IO_VAOD: "",
            S_OP_IO_VAOS: "",
            S_OP_IO_XOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_XOD,
            S_OP_IO_XOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_XOS
          },
          S_OP_Model: "S_OP_IO",
          S_OP_Type: "Inspection"
        },
        {
          S_OP_ChooseId: this.$store.state.physicianVisits.xzConsulting,
          S_OP_CustomerId: this.$store.state.users.CsUser.CustomerId,
          S_OP_ExpertId: this.$store.state.users.employees?this.$store.state.users.employees.ExpertId:'00000000-0000-0000-0000-000000000000',
          S_OP_ID: "00000000-0000-0000-0000-000000000000",
          S_OP_Json:{
            S_OP_IO_ADDOD: "",
            S_OP_IO_ADDOS: "",
            S_OP_IO_ArriseOD: "",
            S_OP_IO_ArriseOS: "",
            S_OP_IO_BCOD: "",
            S_OP_IO_BCOS: "",
            S_OP_IO_BasisOD: "",
            S_OP_IO_BasisOS: "",
            S_OP_IO_ChooseId: this.$store.state.physicianVisits.xzConsulting,
            S_OP_IO_DCOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DCOD,
            S_OP_IO_DCOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DCOS,
            S_OP_IO_DIMOD: "",
            S_OP_IO_DIMOS: "",
            S_OP_IO_DSOD:gbjh(this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DSOD) ,
            S_OP_IO_DSOS:gbjh(this.$store.state.eyeTest.refractiveData.S_OP_R_SS_DSOS),
            S_OP_IO_DVAOD: "",
            S_OP_IO_DVAOS: "",
            S_OP_IO_FrameType: "",
            S_OP_IO_NVAOD: "",
            S_OP_IO_NVAOS: "",
            S_OP_IO_Number: "",
            S_OP_IO_PDOD: "",
            S_OP_IO_PDOS: "",
            S_OP_IO_PHOD: "",
            S_OP_IO_PHOS: "",
            S_OP_IO_Remark: "",
            S_OP_IO_Type: "7",
            S_OP_IO_VAOD: "",
            S_OP_IO_VAOS: "",
            S_OP_IO_XOD: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_XOD,
            S_OP_IO_XOS: this.$store.state.eyeTest.refractiveData.S_OP_R_SS_XOS
          },
          S_OP_Model: "S_OP_IO",
          S_OP_Type: "Inspection"
        }
      ],
      cfarr: [],
      czjd: cfObj.czjd,
      jd: cfObj.jd
    }
  },
  created() {
    let log = this.$loading({text: '加载中...'})
    this._api.expertClinic.getViewPlan()
        .then(res => {
          log.close()
          if (res.GetListResult && res.GetListResult.length > 0) {
            let arr = res.GetListResult.filter(item => item.S_OP_Model == "S_OP_IO")
            this.cfarr = arr.map(item => {
              item.S_OP_Json = this._clJson(item.S_OP_Json)
              item.S_OP_Json.S_OP_IO_DSOD = gbjh(item.S_OP_Json.S_OP_IO_DSOD)
              item.S_OP_Json.S_OP_IO_DSOS = gbjh(item.S_OP_Json.S_OP_IO_DSOS)
              // this.exid = item.S_OP_ExpertId
              return item
            })
          }


        })
  },
  methods: {
    addcf() {
      if (!this.cfValue) return this.$alert('请选择使用类型', "提示")
      if (this.cfValue == 1) {
        this.cfarr.push(JSON.parse(JSON.stringify(this.ysArr[0])))
      }
      if (this.cfValue == 2) {
        this.cfarr.push(JSON.parse(JSON.stringify(this.ysArr[1])))
      }
      if (this.cfValue == 3) {
        this.cfarr.push(JSON.parse(JSON.stringify(this.ysArr[2])))
      }
    },
    sgsqm() {
      let log = this.$loading({text: '签名中...'})
      this._api.expertClinic.sgsqm()
          .then(res => {
            // console.log(res)
            log.close()
            if (typeof res === 'object') {
              if (res.InsertResult) {
                this.$store.commit('physicianVisits/upissgqm', false)
                this.$alert('提交签名成功', '提示')
              }else {
                this.$alert('提交签名失败', '提示')
              }
            }
          })

    },
    saves() {
      let log = this.$loading({text: '保存中...'})
      saveFA(this.cfarr)
      .then(res => {
        log.close()
        this.$alert(res.msg, '提示')
      })
    },


    jhbh(e, item, key) {
     if (item.S_OP_Json[key]) {
       if (item.S_OP_Json[key] > 0 && item.S_OP_Json[key].indexOf('+') < 0) {
         let str = item.S_OP_Json[key].toString()
         item.S_OP_Json[key] = "+" +  str
       }
     }
    }
  }
}
</script>

<style scoped lang="scss">
.CF {
  color: #0a0a0a;
}
.aitj {
  height: 50px;
  width: calc(100% - 20px);
  border-radius: 5px;
  overflow-y: auto;
  background: #ececec;
  text-align: left;
  padding: 10px;
}
.yopss {
  display: flex;
  align-items: center;
  padding-top: 10px;
}
.contenss {
  height: 50vh;
  overflow-y: auto;
}
.cfyy {
  padding-top: 20px;
  ul {
    display: flex;
    border: 1px solid #7f7e7e;
    li {
      width: 88px;
      border-right: 1px solid #7f7e7e;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px 0;
      input {
        width: 100%;
        text-align: center;
        border: none;
      }
    }
  }
}
.cfjy {
  padding-top: 20px;
  ul {
    display: flex;
    border: 1px solid #7f7e7e;
    li {
      width: 191px;
      border-right: 1px solid #7f7e7e;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px 0;
      input {
        width: 100%;
        text-align: center;
        border: none;
      }
    }
  }
}
.cfjmjcj {
  padding-top: 20px;
  ul {
    display: flex;
    border: 1px solid #7f7e7e;
    li {
      width: 163px;
      border-right: 1px solid #7f7e7e;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px 0;
      input {
        width: 100%;
        text-align: center;
        border: none;
      }
    }
  }
}
</style>
